import axios from "axios";
import { QueryGenerator } from "../helpers/redux.utilities";
import { BACK_URI } from "./keys";

const getUserConfig = () => {
  if (!localStorage.getItem("userInfo")) {
    return;
  }
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const config = {
    headers: {
      Authorization: userInfo.token,
    },
  };
  return config;
};

export const searchProducts = async (search, size, filters) => {
  let query = await QueryGenerator({ ...filters });
  const { data } = await axios.get(
    `${BACK_URI}/product/search/dashboard${query}&search=${search}&pagesize=${size}&lookup=lookup`,
    getUserConfig()
  );
  return data.products;
};

export const searchCustomers = async (search) => {
  const { data } = await axios.post(`${BACK_URI}/customer/search`, { search }, getUserConfig());
  return data;
};

export const getCustomerOrders = async (id) => {
  const { data } = await axios.get(
    `${BACK_URI}/order/listallorders?pagenumber=1&user=${id}`,
    getUserConfig()
  );
  return data.allOrders;
};
